module.exports = __webpack_public_path__ + "static/media/queries.2241b5b2.jpg";